import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'

export default [
    {
        path: '/ehr/index',
        name: 'ehr.index',
        view: 'ehr/EhrIndex',
        default: {},
        middlewares: [RequireUserMiddleware],
    },
    {
        path: '/ehr/referrals/new/make',
        name: 'ehr.referrals.new.make',
        view: 'ehr/EhrMake',
        default: {},
        middlewares: [RequireUserMiddleware],
    },
    {
        path: '/ehr/referrals/ancillary-services-tests',
        name: 'ehr.referrals.services.tests',
        view: 'ehr/EhrAncillaryServiceTests',
        middlewares: [RequireUserMiddleware],
    },
]
